import { SignalDocumentGroup } from "./groupSignals";
import { isSignalUnread } from "./signalUnread";

export type SignalGroupReadStatus = "unread" | "read" | "partial";

export const signalGroupReadStatus = (
  group: SignalDocumentGroup,
  treatUnread?: ReadonlySet<string>,
): SignalGroupReadStatus => {
  const unreadCount = group.signals.filter(
    (signal) => isSignalUnread(signal) || treatUnread?.has(signal.docId),
  ).length;
  if (unreadCount === 0) return "read";
  if (unreadCount === group.signals.length) return "unread";
  return "partial";
};

export const matchesSignalReadFilter = (
  group: SignalDocumentGroup,
  isUnread: boolean | undefined,
  treatUnread?: ReadonlySet<string>,
): boolean => {
  if (isUnread === undefined) return true;
  const status = signalGroupReadStatus(group, treatUnread);
  if (isUnread) return status !== "read";
  return status === "read";
};
